module.exports = __webpack_public_path__ + "img/qr-code.4c37cd6c.svg";